import { apiRequest, buildApiUrl, readJsonOrThrow } from "@/api/client";

export async function prepareConverterJob(session, payload) {
  const response = await apiRequest("/momo/converter/jobs/prepare", {
    method: "POST",
    session,
    body: payload,
  });
  return readJsonOrThrow(response, "Failed to prepare converter job");
}

export async function fetchConverterJobs(session) {
  const response = await apiRequest("/momo/converter/jobs", {
    session,
    includeContentType: false,
  });
  return readJsonOrThrow(response, "Failed to fetch converter jobs");
}

// Legacy endpoint kept for backward compatibility with old range-editor flow.
export async function requestConverterRender(session, jobId, payload) {
  const response = await apiRequest(
    `/momo/converter/jobs/${encodeURIComponent(jobId)}/render`,
    {
      method: "POST",
      session,
      body: payload,
    }
  );
  return readJsonOrThrow(response, "Failed to request converter render");
}

export function buildConverterSourceVideoUrl(jobId, token) {
  const safeJobId = encodeURIComponent(String(jobId || "").trim());
  const safeToken = encodeURIComponent(String(token || "").trim());
  return `${buildApiUrl(`/momo/converter/jobs/${safeJobId}/source-video`)}?access_token=${safeToken}`;
}
